import { ThemeFamilies } from './types';
var getChip = function (colors) {
    var _a;
    return (_a = {},
        _a[ThemeFamilies.DEFAULT] = {
            main: colors.surface3,
            light: colors.surface4,
            dark: colors.surface1,
            text: colors.disabled,
            selectedText: colors.white,
            disabled: colors.surface4,
            disabledText: colors.surface2,
        },
        _a[ThemeFamilies.PRIMARY] = {
            main: colors.surfaceFamilies.selectedHover,
            light: colors.surfaceFamilies.highlights,
            dark: colors.info,
            text: colors.info,
            selectedText: colors.white,
            disabled: colors.surface4,
            disabledText: colors.surface2,
        },
        _a[ThemeFamilies.SUCCESS] = {
            main: colors.surfaceFamilies.successHover,
            light: colors.surfaceFamilies.success,
            dark: colors.success,
            text: colors.success,
            selectedText: colors.white,
            disabled: colors.surface4,
            disabledText: colors.surface2,
        },
        _a[ThemeFamilies.WARNING] = {
            main: colors.surfaceFamilies.warningHover,
            light: colors.surfaceFamilies.warning,
            dark: colors.warning,
            text: colors.warning,
            selectedText: colors.white,
            disabled: colors.surface4,
            disabledText: colors.surface2,
        },
        _a[ThemeFamilies.ERROR] = {
            main: colors.surfaceFamilies.errorHover,
            light: colors.surfaceFamilies.error,
            dark: colors.error,
            text: colors.error,
            selectedText: colors.white,
            disabled: colors.surface4,
            disabledText: colors.surface2,
        },
        _a);
};
export default getChip;
